import './PriceAlertListing.scss';
import { format } from 'date-fns';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import Table from '../../../../common/Table/Table';
import Modal from '../../../../common/Modals/Modal/Modal';
import { DeleteIcon } from '../../../../../assets/icons/svgicons';
import Commonpagination from '../../../../common/Pagination/Commonpagination';
import { deletePriceAlertsAction, getPriceAlertsListAction } from '../../../../../features/user/userSlice';

const PriceAlertListing = ({ show, handleClose }) => {

    const dispatch = useDispatch()
    const [page, setPage] = useState(1)
    const [loading, setLoading] = useState(false)
    const [update, setUpdate] = useState(false)
    const [data, setData] = useState({
        currentPage: 1,
        list: [],
        totalItems: 0,
        totalPages: 1
    })

    const listHeaders = [
        { label: "Amount" },
        { label: "Type" },
        { label: "Alert" },
        { label: "Date" },
        { label: "Action" },
    ];

    useEffect(() => {
        const getPriceList = async () => {
            setLoading(true)
            try {
                const payload = {
                    page: page,
                    size: 5
                }
                const res = await dispatch(getPriceAlertsListAction(payload))
                if (res?.data?.status === 200) {
                    const data = res?.data?.data || {}
                    setData({
                        currentPage: data?.currentPage,
                        list: data?.list,
                        totalItems: data?.totalItems,
                        totalPages: data?.totalPages
                    })
                }
            } catch (error) {
                console.log(error, "error")
            } finally {
                setLoading(false)
            }
        }
        getPriceList()
    }, [page, update])


    const deletePriceAlert = async (id) => {
        setLoading(true)
        try {
            const res = await dispatch(deletePriceAlertsAction({ id: id }))
            if (res?.data?.status === 200) {
                setUpdate((prev) => !prev)
            }
        } catch (error) {
            console.log(error, "error");
        } finally {
            setLoading(false)
        }
    }

    return (
        <Modal
            show={show}
            handleClose={handleClose}
            className="pricelistmodal"
            title='Price Alert List'
        >
            <div className="tab_data">
                <Table
                    noRecordContent={"No records were found."}
                    noContentVariant="large"
                    loading={loading}
                    loadingClassName={"loading_table"}
                    className="table"
                    fields={listHeaders}
                >
                    {data?.list?.length > 0 ? (
                        data?.list?.map((item, index) => (
                            <tr key={index}>
                                <td>{item?.target_price || "NA"}</td>
                                <td>{item?.metal_type || "NA"}</td>
                                <td>{item?.condition === "GT" ? "Greater than equal to " : "Less than equal to " || "NA"}</td>
                                <td>{format(new Date(item?.created_at), "dd MMM, yyyy") || "NA"}</td>
                                <td style={{ cursor: "pointer" }} onClick={() => deletePriceAlert(item?.id)}><DeleteIcon /></td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td
                                colSpan={listHeaders?.length}
                                style={{ textAlign: "center" }}
                            >
                                No records found!
                            </td>
                        </tr>
                    )}
                </Table>

                {data?.totalPages > 1 &&
                    <Commonpagination
                        pagination
                        currentPage={data?.currentPage}
                        // className={styles.pagination}
                        pageSize={10}
                        totalPages={data?.totalPages}
                        handlePageChange={(selected) => setPage(selected)}
                    />}
            </div>
        </Modal>
    );
};

export default PriceAlertListing;
